import { render, staticRenderFns } from "./OccupancyPlan.vue?vue&type=template&id=b9044672&"
import script from "./OccupancyPlan.vue?vue&type=script&lang=js&"
export * from "./OccupancyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports